class TextAnimationController {
  constructor() {
    this.events();
  }

  events() {
    window.addEventListener('DOMContentLoaded', (event) => {

      ////////////////////////////////////////
      // TEXT ANIMATION
      let TextObserver = new IntersectionObserver((entries, TextObserver) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in');
            TextObserver.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: "0px 0px -100px 0px"
      });
      document.querySelectorAll('.text-observed').forEach(box => {
        TextObserver.observe(box)
      });
      // INTERSECTION OBSERVER TEXT ANIMATIONS
      ////////////////////////////////////////

    });
  }
}

export default TextAnimationController;